import TabsControl from './tabs-control'
import ButtonControl from './button-control'
import CompactButtonControl from './compact-button-control'
import RangeSliderControl from './range-slider-control'
import CreatorControl from './creator-control'
import SearchControl from './search-control'
import LockerEditorControl from './locker-editor-control'
import ScheduleEditorControl from './schedule-editor-control'
import InlineErrorControl from './inline-error-control'
import GenericUploadControl from './generic-upload-control'
import ProgressCircleControl from './progress-circle-control'
import ProgressLineControl from './progress-line-control'
import PostFileUploadControl from './post-file-upload-control'
import CreatorImageUploadControl from './creator-image-upload-control'
import CreatorMentionDropdownControl from './creator-mention-dropdown-control'
import CustomScrollbarControl from './custom-scrollbar-control'
import TagBoxControl from './tag-box-control'
import VideoPlayerControl from './video-player-control'
import SelectOptionButtonControl from './select-option-button-control'
import DummyCropperControl from './dummy-cropper-control'
import NotificationsControl from './notifications-control'
import SelectFilterControl from './select-filter-control'
import StaticLoaderControl from './static-loader-control'
import FitTruncateTextControl from './fit-truncate-text-control'
import GenericSquareCardControl from './generic-square-card-control'
import PostFeedControl from './post-feed-control'
import IconButtonControl from './icon-button-control'
import IconToggleControl from './icon-toggle-control'
import EmojiPickerControl from './emoji-picker-control'
import CreatorSearchControl from './creator-search-control'
import CartButtonControl from './cart-button-control'
import MediaListControl from './media-list-control'
import MediaListControlItem from './media-list-control-item'
import MediaVaultUploadControl from './media-vault-upload-control'
import MediaFeedControl from './media-feed-control'
import ProfileFilesContainerControl from './profile-files-container-control'
import CreatorsListControl from './creators-list-control'
import VideoSuggestionsControl from './video-suggestions-control'
import ProfileSuggestionsControl from './profile-suggestions-control'
import StoreSliderControl from './store-slider-control'
import OnlineUsersControl from './online-users-control'
import GuestFooterControl from './guest-footer-control'
import imageEditor from './image-editor'
import videoEditor from './video-editor'
import DashboardTablePaging from './dashboard-table-paging'


export default {
    TabsControl,
    ButtonControl,
    CompactButtonControl,
    RangeSliderControl,
    CreatorControl,
    SearchControl,
    LockerEditorControl,
    ScheduleEditorControl,
    InlineErrorControl,
    GenericUploadControl,
    ProgressCircleControl,
    ProgressLineControl,
    PostFileUploadControl,
    CreatorImageUploadControl,
    CreatorMentionDropdownControl,
    CustomScrollbarControl,
    TagBoxControl,
    VideoPlayerControl,
    SelectOptionButtonControl,
    DummyCropperControl,
    NotificationsControl,
    SelectFilterControl,
    StaticLoaderControl,
    FitTruncateTextControl,
    GenericSquareCardControl,
    PostFeedControl,
    IconButtonControl,
    IconToggleControl,
    EmojiPickerControl,
    CreatorSearchControl,
    CartButtonControl,
    MediaListControl,
    MediaListControlItem,
    MediaVaultUploadControl,
    MediaFeedControl,
    ProfileFilesContainerControl,
    CreatorsListControl,
    VideoSuggestionsControl,
    ProfileSuggestionsControl,
    StoreSliderControl,
    OnlineUsersControl,
    GuestFooterControl,
    ...imageEditor,
    ...videoEditor,
    DashboardTablePaging,
}
